import { render, staticRenderFns } from "./bbs.vue?vue&type=template&id=243f7b0a&scoped=true&"
import script from "./bbs.js?vue&type=script&lang=js&"
export * from "./bbs.js?vue&type=script&lang=js&"
import style0 from "./bbs.css?vue&type=style&index=0&id=243f7b0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f7b0a",
  null
  
)

export default component.exports